import has from 'lodash/has';

import { loanTypes } from '~/constants/loanTypes';

export const validOfferType = (type) => {
  return (has(loanTypes, type));
};
